module.exports = __webpack_public_path__ + "img/img1.dffce4c7.png";